import { qs } from '@chipinside/hooks'
import { Translate } from '@chipinside/translate'

import { PageConditions, PageId, PagesService } from '#/store/services/Pages/PagesService'
import { store } from '#/store/store'
// @ts-ignore
const item = messageKey => Translate({ lower: true, messageKey })

export const getLinkTooltip = linkTo => {
  const access = messageKey =>
    Translate({ messageKey: 'access_item', params: { item: item(messageKey) } })

  if (linkTo === 'farm-batch-profile-consumption') return access('profile_and_intake')
  if (linkTo.startsWith('farm-animal-')) return access('animal')
  if (linkTo.startsWith('farm-batch-')) return access('actual_batch')
  if (linkTo === 'farm-dashboard' || linkTo.startsWith('system-accounts-farm-'))
    return access('farm')
  if (linkTo.startsWith('system-accounts-company-')) return access('company')
  if (linkTo.startsWith('farm-thermal-stress-')) return access('environmental_comfort')
  if (linkTo.startsWith('system-inventory-c-com-')) return access('c_com_details')
  if (linkTo.startsWith('farm-reproduction-protocol-')) return access('protocol')
  if (linkTo.startsWith('farm-health-protocol-detail-')) return access('health_protocols')
  if (linkTo.startsWith('farm-health-protocol-models-')) return access('model')
  if (linkTo.startsWith('system-cs-nps-campaign-')) return access('campaign')
  if (linkTo.startsWith('system-c-tech-break-')) return access('farm_distribution')
  if (linkTo.startsWith('system-inventory-c-tech-farm-')) return access('operational_status')
  if (linkTo.startsWith('system-c-com-farm-')) return access('c_com')
  if (linkTo.startsWith('system-cs-customer-center-'))
    return Translate({ messageKey: 'access_item' })
  if (linkTo.startsWith('system-data-interval-')) return access('data_interval')
  if (linkTo.startsWith('farm-milk-control-')) return access('production_details')

  return Translate({ messageKey: 'access_item' })
}

export type GetLinkProps = {
  id: PageId
  params?: Record<string, any>
  query?: Record<string, string>
  fallback?: PageId
  additionalEnabled?: (conditions?: PageConditions) => boolean
}

export function getLink({
  additionalEnabled,
  fallback,
  id,
  params,
  query,
}: GetLinkProps): string | undefined {
  const { auth, context, farm, permissions } = store.getState() as any

  const pages = new PagesService(
    {
      farm_count: auth?.user?.farm_count,
      farm_plan: farm?.farm?.plan?.slug,
      has_company: auth?.user?.has_company,
      is_female: context?.animal?.is_female,
      permissions: permissions?.permissions,
      point: context?.thi?.id,
      productionType: context?.production?.type,
      secondPregnancy: farm?.farm?.second_pregnancy_confirmation_active,
      thirdPregnancy: farm?.farm?.third_pregnancy_confirmation_active,
      ...params,
    },
    { params: { farm: farm?.farm?.slug, ...params } },
  )

  const page = pages.getById(id, { additionalEnabled })

  if (!page?.enabled) {
    if (fallback) {
      return getLink({ id: fallback, params, query })
    }

    return
  }

  let link = page.link

  if (query) {
    const queryString = qs.stringify(query)
    link += `?${queryString}`
  }

  return link
}
